import React from "react";
import styled from "styled-components";
import { Button as AntButton, Radio } from "antd";
import { LeftOutlined } from "@ant-design/icons";

import colors from "constants/palette";
// import Fetch from "components/Fetch";
import Loading from "components/App/Loading";
import { Header } from "components/App/styled";
import { List, ListRow } from "components/Tables/List";

export default function Themes({ returnPage }) {
  const currentTheme = colors.dark === "#3A4041" ? 0 : 1;
  function onLightClick() {
    localStorage.setItem(
      "_theme",
      JSON.stringify({
        ...colors,
        primary: "#3A4041",
        secondary: "#DFDF2B",
        white: "#ffffff",
        dark: "#3A4041",
        gray: "#484848",
        red: "#F63528",
        green: "#46af4a",
        blue: "#1890FF",
        yellow: "#ffeb3b",
      })
    );
    window.location.reload();
  }
  function onDarkClick() {
    localStorage.setItem(
      "_theme",
      JSON.stringify({
        ...colors,
        dark: "#ffffff",
        white: "#232323",
        primary: "#1890ff",
      })
    );
    window.location.reload();
  }

  return (
    <Container>
      <Col>
        <HeaderContainer>
          <Header>تنظیمات پوسته</Header>
          <BackBtn shape="round" icon={<LeftOutlined />} onClick={returnPage} />
        </HeaderContainer>
        <List>
          <ListRow
            style={{
              marginBottom: 8,
            }}
          >
            <Radio.Group
              options={themesList}
              onChange={(e) => {
                if (e.target.value) {
                  onDarkClick();
                } else {
                  onLightClick();
                }
              }}
              value={currentTheme}
              optionType="button"
              buttonStyle="solid"
            />
          </ListRow>
        </List>
        <ImageGrid>
          {imagesList?.length ? (
            imagesList.map((item, index) => (
              <ImageContainer onClick={item.onClick} key={index}>
                {index === 0 ? (
                  <span className="title-row">{item.title}</span>
                ) : (
                  <span className="image-row">
                    <PreviewImage
                      src={`${process.env.REACT_APP_URL}/images/background-${index}.jpg`}
                      alt=""
                    />
                  </span>
                )}
              </ImageContainer>
            ))
          ) : (
            <div style={{ height: 200 }}>
              <Loading />
            </div>
          )}
        </ImageGrid>
      </Col>
    </Container>
  );
}
const Container = styled.div`
  display: flex;
  padding: 26px 20px;
  width: 100%;

  @media (max-width: 1280px) {
    flex-direction: column;
    min-height: calc(100vh - 210px);
  }
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;

  @media (max-width: 1280px) {
    margin-right: 0;
    margin-left: 0;
  }
`;

const BackBtn = styled(AntButton)`
  margin-bottom: 10px;
  display: none;
  background: transparent;
  color: ${colors.dark};
  &:hover {
    background: transparent;
  }

  @media (max-width: 720px) {
    display: block;
  }
`;

const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ImageContainer = styled.div`
  border: 1px solid white;
  width: 200px;
  height: 200px;
  margin-left: 16px;
  margin-top: 16px;

  border-radius: 5px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  &:hover {
    cursor: pointer;
    border-color: ${colors.green};
    transform: scale(1.07);
  }

  & .image-row {
    text-align: center;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 720px) {
    width: 100px;
    height: 100px;
  }
`;
const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

// setting items :::
const themesList = [
  {
    label: "عادی",
    value: 0,
  },
  {
    label: "تاریک",
    value: 1,
  },
];

const imagesList = [
  {
    title: "بدون تصویر",
    onClick: () => {
      localStorage.setItem(
        "_theme",
        JSON.stringify({ ...colors, bgImage: false })
      );
      window.location.reload();
    },
  },
  {
    title: "تصویر 1",
    onClick: () => {
      localStorage.setItem(
        "_theme",
        JSON.stringify({
          ...colors,
          bgImage: "1",
        })
      );
      window.location.reload();
    },
  },
  {
    title: "تصویر 2",
    onClick: () => {
      localStorage.setItem(
        "_theme",
        JSON.stringify({
          ...colors,
          bgImage: "2",
        })
      );
      window.location.reload();
    },
  },
  {
    title: "تصویر 3",
    onClick: () => {
      localStorage.setItem(
        "_theme",
        JSON.stringify({
          ...colors,
          bgImage: "3",
        })
      );
      window.location.reload();
    },
  },
  {
    title: "تصویر 4",
    onClick: () => {
      localStorage.setItem(
        "_theme",
        JSON.stringify({
          ...colors,
          bgImage: "4",
        })
      );
      window.location.reload();
    },
  },
  {
    title: "تصویر 5",
    onClick: () => {
      localStorage.setItem(
        "_theme",
        JSON.stringify({
          ...colors,
          bgImage: "5",
        })
      );
      window.location.reload();
    },
  },
  {
    title: "تصویر 6",
    onClick: () => {
      localStorage.setItem(
        "_theme",
        JSON.stringify({
          ...colors,
          bgImage: "6",
        })
      );
      window.location.reload();
    },
  },
];
